import './Home.scss';
import {Link} from "react-router-dom";
// import {socialsData} from "../../data/Home/socialsData";
import {BsArrowRight} from "react-icons/bs";

function Home() {

    return(
        <>
                <div className="flex-1 flex flex-col justify-center container mx-auto w-full mx-auto text-left md:text-center p-3">
                    <p className="text-5xl font-black font-circular-black">
                        Hey there, <br/> this is <span className="pv3__HomeGradientText">Samuel Amagbakhen.</span></p>
                    <p className="w-full md:mx-auto lg:w-1/2 mt-3 leading-10 text-xl mt-8">
                        A <span className="inline-block bg-secondary-text-color text-white rounded  px-1.5">frontend developer</span> developing and maintaining applications on the web.
                        I help companies translate their business ideas into technical specifications using modern web technologies. I have experience in building efficient, clean and scalable web applications.
                    </p>
                    <p className="w-full md:mx-auto lg:w-1/2 mt-3 leading-10 text-xl mt-3">
                        Currently, I'm exploring the backend facing side of web applications using Laravel and PHP.
                    </p>
                </div>
                <div className="mt-0 sm:mt-8 container mx-auto">
                    <Link to={'/projects'} className="text-2xl hover-secondary-text-color inline-block
                  font-extrabold after:content-[''] after:w-20
                  after:block after:h-0.5 after:bg-white pv3__viewMyProjects
                  transition duration-500 ease-in-out
                  after:transition-all after:delay-300">
                        View My Projects  &nbsp;  <BsArrowRight className="inline pv3__viewMyProjectsIcon"/>
                    </Link>
                </div>
               <div className="mt-3 md:mt-auto mb-14 md:flex hidden justify-between items-center">

                {/*<div className="social-media-icons flex flex-nowrap font-extrabold">*/}
                {/*    {socialsData.map(social => (*/}
                {/*        <a className="px-3 flex flex-nowrap items-center hover-secondary-text-color transition duration-500 ease-in-out"*/}
                {/*              href={social.url}*/}
                {/*              key={social.id}*/}
                {/*              target="_blank"*/}
                {/*              rel="noopener noreferrer">*/}
                {/*            {social.icon}&nbsp;&nbsp;{social.name} &nbsp;*/}
                {/*            <BsArrowUpRight className="inline"/>*/}
                {/*        </a>*/}
                {/*    ))*/}
                {/*    }*/}
                {/*</div>*/}
            </div>
            <div className="pb-24 sm:pb-0"></div>
        </>
    );
}

export default Home;